import { CatalogShortFormContentResponseTypename } from '../../../__generated__/chirp/com/hubspot/academy/catalog/rpc/v1/CatalogResourceChirpFrontendService';
const isShortFormContent = resource => resource.__typename === CatalogShortFormContentResponseTypename;
export const unwrapCatalogResourceShortFormContentChirpError = ({
  error,
  data
}) => {
  var _data$results;
  if (error) {
    const networkError = error.networkError;
    if (networkError) {
      var _networkError$cause, _networkError$cause2, _networkError$respons, _networkError$respons2;
      const status = networkError.status || networkError.statusCode || ((_networkError$cause = networkError.cause) === null || _networkError$cause === void 0 ? void 0 : _networkError$cause.status) || ((_networkError$cause2 = networkError.cause) === null || _networkError$cause2 === void 0 ? void 0 : _networkError$cause2.statusCode) || ((_networkError$respons = networkError.response) === null || _networkError$respons === void 0 ? void 0 : _networkError$respons.status) || ((_networkError$respons2 = networkError.response) === null || _networkError$respons2 === void 0 ? void 0 : _networkError$respons2.statusCode);
      return {
        shortFormContent: undefined,
        shortFormContentError: {
          status: status || 500,
          networkError
        }
      };
    }
    return {
      shortFormContent: undefined,
      shortFormContentError: {
        status: 500,
        networkError: error
      }
    };
  }
  if (!data) {
    return {
      shortFormContent: undefined,
      shortFormContentError: undefined
    };
  }
  const shortFormContent = (_data$results = data.results) === null || _data$results === void 0 ? void 0 : _data$results.find(isShortFormContent);
  if (!shortFormContent) {
    return {
      shortFormContent: undefined,
      shortFormContentError: {
        status: 404,
        networkError: {
          status: 404
        }
      }
    };
  }
  return {
    shortFormContent,
    shortFormContentError: undefined
  };
};
export const unwrapPublicShortFormContentChirpError = ({
  error,
  data
}) => {
  if (error) {
    const networkError = error.networkError;
    if (networkError) {
      var _networkError$cause3, _networkError$cause4, _networkError$respons3, _networkError$respons4;
      const status = networkError.status || networkError.statusCode || ((_networkError$cause3 = networkError.cause) === null || _networkError$cause3 === void 0 ? void 0 : _networkError$cause3.status) || ((_networkError$cause4 = networkError.cause) === null || _networkError$cause4 === void 0 ? void 0 : _networkError$cause4.statusCode) || ((_networkError$respons3 = networkError.response) === null || _networkError$respons3 === void 0 ? void 0 : _networkError$respons3.status) || ((_networkError$respons4 = networkError.response) === null || _networkError$respons4 === void 0 ? void 0 : _networkError$respons4.statusCode);
      return {
        shortFormContent: undefined,
        shortFormContentError: {
          status: status || 500,
          networkError
        }
      };
    }
    return {
      shortFormContent: undefined,
      shortFormContentError: {
        status: 500,
        networkError: error
      }
    };
  }
  if (!data) {
    return {
      shortFormContent: undefined,
      shortFormContentError: undefined
    };
  }
  const shortFormContent = data.short;
  if (!shortFormContent) {
    return {
      shortFormContent: undefined,
      shortFormContentError: {
        status: 404,
        networkError: {
          status: 404
        }
      }
    };
  }
  return {
    shortFormContent,
    shortFormContentError: undefined
  };
};